import script from "./AddUserToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserToWorkspaceModal.vue?vue&type=style&index=0&id=e925cde8&lang=scss&scoped=true"
import "./AddUserToWorkspaceModal.vue?vue&type=style&index=1&id=e925cde8&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e925cde8"]])

export default __exports__